<template>
  <div style="opacity: 0.5; background-image: url('/img/editor/zodiac/stars.svg')"
       class="absolute inset-0 rounded-full">
  </div>
</template>

<script>
export default {
  name: "StarsBackgroundLayer"
}
</script>

<style scoped>

</style>